import PencilIconPath from "@ingka/ssr-icon/paths/pencil";

export default PencilIconPath;
